import React from 'react';

interface AvatarProps {
  name: string;
  size?: number;
  fontSize?: number;
}

// Every entry carries white initials at 4.5:1 or better (the previous pink, amber, teal and
// violet were 2.1–3.5:1).
const PALETTE = ['var(--electric)', '#6D28D9', 'var(--green)', '#9A4A00', 'var(--red)', '#A3195B', '#0F6E6E', 'var(--nycem-blue)'];

function hashName(name: string): number {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = ((h << 5) - h + name.charCodeAt(i)) | 0;
  return Math.abs(h);
}

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return (parts[0][0] ?? '?').toUpperCase();
  return ((parts[0][0] ?? '') + (parts[parts.length - 1][0] ?? '')).toUpperCase();
}

const Avatar: React.FC<AvatarProps> = ({ name, size = 32, fontSize }) => {
  const bg = PALETTE[hashName(name) % PALETTE.length];
  const fs = fontSize ?? Math.round(size * 0.38);
  return (
    <div
      title={name}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: bg,
        color: 'var(--white)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: fs,
        fontWeight: 700,
        flexShrink: 0,
        userSelect: 'none',
        letterSpacing: '0.02em',
      }}
    >
      {getInitials(name)}
    </div>
  );
};

export default Avatar;
